import template from './land.jade';
import landTypeOptions from '../../../enums/land-type';
import validation from '../../../services/validation';

export default angular.module('cian.addForm.buildingLand', []).directive('cianAfAboutBuildingLand', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller(deviceService) {
    'ngInject';
    this.isMobile = deviceService.isMobile;
    this.areaMin = 0;
    this.areaMax = 1e7;
    this.validation = validation(this.form, 'land.area', {
      parse: 'Введите число',
      min: 'Введите число',
      max: 'Допустимо не более 7 символов',
    });
    this.typeOptions = landTypeOptions;
    this.ad.land = this.ad.land || {};
    this.ad.land.type = this.ad.land.type || this.typeOptions[0].value;
    this.ad.land.areaUnitType = 'hectare';
  },
  controllerAs: 'land',
  template,
})).name;
